import React from 'react';
import { Link } from 'gatsby'
import BackgroundImage from 'gatsby-background-image'

import LinkedIn from "./Linkedin.js"
import Mail from "./email.js"




const ContactObject = props => {
  return(
      <div className="column-group ">
        <div className="xlarge-90 large-90 small-90 tiny-90 medium-90 push-left">
    {props.data !== null ?
    props.data.map((document, index) => (
    document.showBioPage ?
                      <div className="xlarge-35 large-35 small-100 tiny-100 medium-50 push-left">
                  <Link  to={`/people/${document.slug}`}>
                  <div className="author-wrapper" style={{color:props.color}} >
                      <div className="author">
                        <div className="column-group small-gutters tiny-gutters medium-gutters" itemScope itemType="https://schema.org/Person" itemProp="author">
                                    <div className="xlarge-25 large-30 small-20 tiny-20 medium-35 push-left  half-top-space">
                            <BackgroundImage Tag="div" className="AuthorHeadshot" style={{borderColor:props.color}} fluid={document.image.childImageSharp.fluid}/>
                          </div>

                          <div className="xlarge-75 large-70 small-80 tiny-80 medium-65 push-left half-top-space">
                                <div className="column-group">
                                  <div className="all-100 push-left authorName" itemProp="name">
                                 {document.name}
                                </div>
                                <div className="all-100 push-left authorPosition">
                                  {document.position}
                                </div>
                                <div className="all-100 push-left">

                                </div>
                            </div>
                          </div>
                      </div>
                  </div>

                  </div>
                  </Link>
                  </div>

    :
    <div className="xlarge-35 large-35 small-100 tiny-100 medium-50 push-left">
                  <div className="author-wrapper" style={{color:props.color}} >
                      <div className="author">
                        <div className="column-group small-gutters tiny-gutters medium-gutters" itemScope itemType="https://schema.org/Person" itemProp="author">
                          <div className="xlarge-25 large-30 small-20 tiny-20 medium-35 push-left  half-top-space">
                            <BackgroundImage Tag="div" className="AuthorHeadshot" style={{borderColor:props.color}}  fluid={document.image.childImageSharp.fluid}/>
                          </div>

                          <div className="xlarge-75 large-70 small-80 tiny-80 medium-65 push-left half-top-space">
                                <div className="column-group">
                                  <div className="all-100 push-left authorName" itemProp="name">
                                 {document.name}
                                </div>
                                <div className="all-100 push-left authorPosition">
                                  {document.position}
                                </div>
                                <div className="all-100 push-left">
                                <div className="column-group">
                                <div className="all-30 push-left authorIcon ">
                                <a href={document.Social} target="_blank">
                                  <LinkedIn color={props.color} />
                                </a>
                                </div>
                                <div className="all-30 push-left authorIcon ">
                                <a href={`mailto:${document.email}`} target="_blank">
                                  <Mail color={props.color} />
                                </a>
                                </div>
                                </div>
                                </div>
                            </div>
                          </div>
                      </div>

                  </div>

                  </div>
                    </div>

    ))
    :<></>}
    </div>

    </div>

  )

}

export default ContactObject;
